/*
 * Shoperators DECA-624 — filter panel (drawer) helpers.
 * Works on top of the theme's facets.js; filtering logic is unchanged.
 *  - keeps the footer "View N results" label in sync after each filter change
 *  - "View N results" and Escape close the panel
 */
(function () {
  'use strict';

  function container() {
    return document.querySelector('.facets-container--drawer .facets__container');
  }

  function closePanel() {
    var panel = container();
    if (!panel || !panel.classList.contains('active')) return;
    var close = panel.querySelector('.close-drawer');
    if (close) close.click(); // same toggle the theme uses (facets.js bindFacetTriggers)
  }

  function syncCount() {
    var panel = container();
    if (!panel) return;
    var source = panel.querySelector('.deca-facets__count-source');
    var button = panel.querySelector('.deca-facets__view');
    if (source && button && source.textContent.trim()) button.textContent = source.textContent.trim();
  }

  function init() {
    var panel = container();
    if (!panel || panel.dataset.decaFacets) return;
    panel.dataset.decaFacets = 'true';

    panel.addEventListener('click', function (e) {
      if (e.target.closest('.deca-facets__view')) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    // .active-facets-desktop is replaced by facets.js after every change; it carries the new count.
    var applied = panel.querySelector('.active-facets-desktop');
    if (applied) new MutationObserver(syncCount).observe(applied, { childList: true, subtree: true });
    syncCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
